import { Link } from "react-router-dom";

export default function CtaBanner() {
  return (
    <section className="relative overflow-hidden bg-brand py-14 md:py-16">
      <svg className="absolute inset-x-0 top-0 h-12 w-full -translate-y-px text-background" viewBox="0 0 1440 50" preserveAspectRatio="none" aria-hidden>
        <path d="M0,25 C240,50 480,0 720,15 C960,30 1200,50 1440,25 L1440,0 L0,0 Z" fill="currentColor" />
      </svg>
      <div className="container flex flex-col items-center gap-6 text-center">
        <h2 className="max-w-2xl text-3xl font-bold tracking-tight text-white md:text-4xl">
          Ready to upgrade your comfort?
        </h2>
        <p className="max-w-xl text-white/90">
          Tell us about your space and we'll come back with an honest, no-pressure quote within one business day.
        </p>
        <Link
          to="/free-quote"
          className="inline-flex h-12 cursor-pointer items-center justify-center rounded-md bg-white px-8 text-base font-semibold text-brand-700 shadow-lg transition hover:-translate-y-0.5 hover:shadow-xl"
        >
          Get a Free Quote
        </Link>
      </div>
    </section>
  );
}
